import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes} from "react-router-dom";
import Preloader from './util/preloader/Preloader';
import Home from './components/home/Home';
import CourseView from './components/courseView/CourseView'
import Subscription from './components/subscription/Subscription';
import CreateAccount from './components/createAccount/CreateAccount'
import LoginAccount from './components/loginAccount/LoginAccount';
import PaymentSuccess from './components/payment/PaymentSuccess';
import PopularCourseView from './components/courseView/PopularCourseView';
import EnqueryForm from './components/enquery/EnqueryForm';
import RefundPolicy from './components/layout/RefundPolicy';
import GeneralEnquiry from './components/enquery/GeneralEnquiry';
import ReactGA from "react-ga";
import CourseRequestForm from './components/CourseRequestForm/CourseRequestForm';


ReactGA.initialize("G-RF2PR2YXV6");



function App() {

  useEffect(() => {
    // Track page view on component mount
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} ></Route>
          {/* <Route path="/" element={<PaymentSuccess />} ></Route> */}
          <Route path="*" element={<ErrorPage />}></Route>
          <Route path="/home" element={<Home />} ></Route>
          <Route path="/courseView/:courseId" element={<CourseView />} ></Route>
          <Route path="/popularCourseView/:courseId" element={<PopularCourseView />} ></Route>
          <Route path="/subscription/:courseId" element={<Subscription />} ></Route>
          <Route path="/createAccount" element={<CreateAccount />} ></Route>
          <Route path="/loginAccount" element={<LoginAccount />} ></Route>
          <Route path="/EnquiryForm" element={<EnqueryForm />} ></Route>
          <Route path="/RefundPolicy" element={<RefundPolicy />} ></Route>
          <Route path="createAccount/RefundPolicy" element={<RefundPolicy />} ></Route>
          <Route path="EnquiryForm/RefundPolicy" element={<RefundPolicy />} ></Route>
          <Route path="GeneralEnquiry/RefundPolicy" element={<RefundPolicy />} ></Route>
          <Route path="/GeneralEnquiry" element={<GeneralEnquiry />} ></Route>
          <Route path="/CourseRequestForm" element={<CourseRequestForm />} ></Route>



        </Routes>
      </BrowserRouter>

      {/* <Preloader /> */}
      {/* <Header /> */}
      {/* <Home /> */}
      {/* <CourseView /> */}
      {/* <Subscription /> */}
      {/* <CreateAccount /> */}
      {/* <LoginAccount /> */}
      {/* <Footer /> */}

    </div>
  );
}

function ErrorPage() {
  return (
    <React.Fragment>
      <h3>Error Page</h3>
    </React.Fragment>
  );
}

export default App;
